// extracted by mini-css-extract-plugin
module.exports = {"ScrollToTopButton":"ScrollToTopButton-module--ScrollToTopButton--2XSzU","fadeIn":"ScrollToTopButton-module--fadeIn--196M-"};